module.exports = __webpack_public_path__ + "static/media/background5.b26f6b2f.jpg";